import { useContext } from "react"

import { CampaignDispatchType, CampaignDispatchContext, CampaignStateType, CampaignStateContext } from "./CampaignContext.context"

export const useCampaignStateContext = (): CampaignStateType => {
    const context = useContext(CampaignStateContext)
    if (context === undefined) {
        throw new Error("useCampaignStateContext must be used within an CampaignStateContext")
    }
    return context
}

export const useCampaignDispatchContext = (): CampaignDispatchType => {
    const context = useContext(CampaignDispatchContext)
    if (context === undefined) {
        throw new Error("useCampaignDispatchContext must be used within an CampaignDispatchContext")
    }
    return context
}

export const useCampaignContext = (): [CampaignStateType, CampaignDispatchType] => {
    return [useCampaignStateContext(), useCampaignDispatchContext()]
}
